import React, {PureComponent as Component} from 'react';
import KickImage from 'Reuseables/KickImage';
import {Row, Col, Card, CardTitle, CardText} from 'reactstrap';
import classNames from 'classnames';
export default class Notes extends Component{
    render(){
        const { className } = this.props 
        return(            
        <Row className={classNames("notes", className)}>
            <Col className="notes-col" xs={12} md={6}>
                <Card>
                    <CardTitle>
                        Biaya Pengiriman
                    </CardTitle>
                    <CardText>
                        Kami mengirimkan dengan
                        menggunakan perhitungan flat rate.
                        IDR. 40.000,- dalam provinsi DKI Jakarta 
                        dan Jawa Barat, IDR. 80.000,- diluar DKI
                        Jakarta dan Jawa Barat (masih dalam 
                        Pulau Jawa), dan IDR. 120.000,- untuk
                        diluar Pulau Jawa. <br/>
                        Setiap pengiriman sudah termasuk
                        box Kick Avenue dan bubble wrap
                        untuk melindungi box sneakers Anda.
                    </CardText>
                </Card>
            </Col>
            <Col className="notes-col" xs={12} md={6}>
                <Card>
                    <CardTitle>
                        Pengembalian Barang
                    </CardTitle>
                    <CardText>
                        Sneakers hanya dapat direfund jika
                        Anda menyertai pembuktian
                        bahwa sneakers tersebut tidak sesuai
                        dengan kondisi yang tertera pada
                        halaman produk (Baru/Bekas) atau
                        kualitas tidak original. Sebelum
                        melakukan pengembalian barang,
                        harap mengirimkan email ke <br/>
                        <a href="mailto:info@kickavenue.com">info@kickavenue.com</a>
                    </CardText>
                </Card>
            
            </Col>
        </Row>
        )
    }
}